import { render, staticRenderFns } from "./StoryComponent.vue?vue&type=template&id=60fe9006&scoped=true&"
import script from "./StoryComponent.vue?vue&type=script&lang=js&"
export * from "./StoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe9006",
  null
  
)

export default component.exports